<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
      <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Product Summary</h5>
            </div>
            <div class="card-body">
              <div class="form-inline ml-auto">
                <div class="button-group">
                  <button type="button" class="btn btn-sm btn-soft-primary dropdown-toggle" data-toggle="dropdown" id="dropDownFilter">Action<span class="caret"></span></button>
                  <ul class="dropdown-menu p-2" aria-labelledby="dropDownFilter">
                    <li><a href="javascript:void(0)" class="small" tabIndex="-1" data-toggle="modal" data-target="#modalProductCostList" data-backdrop="static" data-keyboard="false">Sync COGS</a></li>
                    <li><a href="javascript:void(0)" class="small" @click="setTotal">Sync Stock</a></li>
                  </ul>
                </div>
                <div class="button-group">
                  <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-filter" aria-hidden="true"></i>
                    Filter
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu p-2" >
                    <span>Status:</span>
                    <div class="dropdown-divider"></div>
                    <li>
                      <a href="#" class="small" tabIndex="-1"><input type="checkbox" :value=true v-model="checkAvailable"/>&nbsp; Available</a>
                    </li>
                    <li>
                      <a href="#" class="small" tabIndex="-1"><input type="checkbox" :value=true v-model="checkKartuStock"/>&nbsp; Check Kartu Stock</a>
                    </li>
                    <div class="dropdown-divider"></div>
                    <span>Category:</span>
                    <div class="dropdown-divider"></div>
                    <li v-for="ct in categoryList" :key="ct.id">
                      <a href="#" class="small" tabIndex="-1">
                        <input type="checkbox" :value="ct.id" v-model="filterCategory"/>&nbsp; {{ ct.name }}
                      </a>
                    </li>
                  </ul>
                  <select class="btn btn-soft-outline-primary btn-sm ml-2" v-model="warehouse">
                    <option value="">-- All --</option>
                    <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no">{{ w.name }}</option>
                  </select>&nbsp;
                  <date-picker v-model="filterDate" type="date" range placeholder="Select date range"></date-picker>&nbsp;
                  <button type="button" class="btn btn-sm  btn-soft-primary waves-light waves-effect" @click="refreshProduct">
                    <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                  </button>
                </div>
                <div class="button-group">
                  <button class="btn btn-warning btn-sm ml-2" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-print" aria-hidden="true"></i> Print <i class="fa fa-caret-down"></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="print">
                    <a class="dropdown-item" href="javascript:void(0)" @click="exportExcel('primary')">Data</a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="exportExcel('all')">All</a>
                  </div>
                </div>
                <div class="button-group">
                  rows:
                  <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                    <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                  </select>
                  <span class="mr-1">Total data: <b>{{ rowsTotal }}</b></span>
                  <span class="mr-1">Total rows: <b>{{ rowsTotal }}</b></span>
                </div>
                <div class="form-group mx-sm-3 mb-2">
                  <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                </div>
                <span class="mr-1">
                  page:
                  <select v-model="currentPage">
                    <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                  </select>
                  / {{ pageLength }}
                </span>
                <nav aria-label="Page navigation example" class="pull-right">
                  <ul class="pagination">
                    <li class="page-item">
                      <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                        <i class="fa fa-angle-left" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li class="page-item">
                      <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
              <ul class="nav nav-tabs nav-bordered">
                <li class="nav-item">
                  <a href="#summary-primary" data-toggle="tab" aria-expanded="false" class="nav-link active">
                    Data
                  </a>
                </li>
                <li class="nav-item">
                  <a href="#summary-all" data-toggle="tab" aria-expanded="true" class="nav-link">
                    All
                  </a>
                </li>
                <li class="nav-item">
                  <a href="#summary-retur" data-toggle="tab" aria-expanded="true" class="nav-link">
                    Retur
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="summary-primary">
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                            <tr>
                                <th>
                                  <label class="form-checkbox">
                                    <input type="checkbox" v-model="selectAll" @click="select">
                                    <i class="form-icon"></i>
                                  </label>
                                </th>
                                <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-if="filterData.length < 1">
                            <td colspan="19" style="text-align: center;"><i>No Data</i></td>
                          </tr>
                          <tr v-for="u in filterData" :key="u.id" style="cursor: pointer">
                            <td>
                              <label class="form-checkbox">
                                <input type="checkbox" :value="u.id" v-model="selected">
                                <i class="form-icon"></i>
                              </label>
                            </td>
                            <td><b>{{ u.product_no }}</b></td>
                            <td>{{ u.product_name }}</td>
                            <td>
                              <select id="uom_id" v-model="u.uom_id" @change="setRow(u.id)">
                                <option v-for="u in u.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                              </select>
                            </td>
                            <td>
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="u.load === true"></span>
                              <span v-else>{{ u.total_begin | currency }}</span>
                            </td>
                            <td>{{ u.total_purchasing | currency }}</td>
                            <td>{{ u.total_adjust | currency }}</td>
                            <td>{{ u.total_adjust_decrease | currency }}</td>
                            <td>{{ u.return_purchasing | currency }}</td>
                            <td>{{ u.total_onHand | currency }}</td>
                            <td>{{ u.total_transfer | currency  }}</td>
                            <!-- <td>{{ u.total_stock_in }}</td> -->
                            <td>{{ u.total_sales | currency  }}</td>
                            <td>{{ u.return_sales | currency  }}</td>
                            <td>{{ u.total_convert_in | currency  }}</td>
                            <td>{{ u.total_convert_out | currency  }}</td>
                            <td>{{ u.total_material | currency  }}</td>
                            <!-- <td>{{ u.total_stock_out }}</td> -->
                            <td>
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="u.load === true"></span>
                              <span v-else>
                                <span v-if="u.total_gudang_round_uom === u.total_gudang_decimal_uom">{{ u.total_gudang | currency }}</span>
                                <span v-else>{{ u.total_gudang_round  | currency }} {{ u.total_gudang_round_uom }} {{ u.total_gudang_decimal  | currency }} {{ u.total_gudang_decimal_uom }}</span>
                              </span>
                            </td>
                            <td>
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="u.load === true"></span>
                              <span v-else>
                                <span v-if="u.total_round_uom === u.total_decimal_uom">{{ u.total | currency }}</span>
                                <span v-else>{{ u.total_round | currency  }} {{ u.total_round_uom }} {{ u.total_decimal | currency  }} {{ u.total_decimal_uom }}</span>
                              </span>
                            </td>
                            <td>
                              <span v-if="u.total_cost === u.total">
                                <span v-if="u.total_cost === '#'">{{ u.total_cost  }} {{ u.total_cost_uom_id }} .</span>
                                <span v-else>{{ u.total_cost | currency  }} {{ u.total_cost_uom_id }} .</span>
                              </span>
                              <span v-else class="badge badge-danger">
                                <!-- {{ u.total_cost | currency  }} {{ u.total_cost_uom_id }} -->
                                <span v-if="u.total_cost === '#'">{{ u.total_cost  }} {{ u.total_cost_uom_id }} .</span>
                                <span v-else>{{ u.total_cost | currency  }} {{ u.total_cost_uom_id }} .</span>
                              </span>
                            </td>
                            <!-- <td>{{ u.total_order | currency }}</td> -->
                          </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
                <div class="tab-pane" id="summary-all">
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                            <tr>
                                <th>
                                  <label class="form-checkbox">
                                    <input type="checkbox" v-model="selectAll" @click="select">
                                    <i class="form-icon"></i>
                                  </label>
                                </th>
                                <th v-for="t in title2" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                                <th @click="sortTable('total_gudang')">
                                  <span v-if="warehouse === 'WH0001'">
                                    Gudang PPN
                                    <div class="float-right fa" v-if="'total_gudang' == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </span>
                                  <span v-else>
                                    Gudang Non PPN
                                    <div class="float-right fa" v-if="'total_gudang' == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </span>
                                </th>
                                <th @click="sortTable('total_remaining')">
                                  <span v-if="warehouse === 'WH0001'">
                                    Gudang Non PPN
                                    <div class="float-right fa" v-if="'total_remaining' == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </span>
                                  <span v-else>
                                    Gudang PPN
                                    <div class="float-right fa" v-if="'total_remaining' == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </span>
                                </th>
                                <th @click="sortTable('total')">
                                  Total Akumulasi
                                  <div class="float-right fa" v-if="'total' == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                                <th @click="sortTable('total_cost')">
                                  Total Kartu Stock
                                  <div class="float-right fa" v-if="'total_cost' == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-if="filterData.length < 1">
                            <td colspan="19" style="text-align: center;"><i>No Data</i></td>
                          </tr>
                          <tr v-for="u in filterData" :key="u.id" style="cursor: pointer">
                            <td>
                              <label class="form-checkbox">
                                <input type="checkbox" :value="u.id" v-model="selected">
                                <i class="form-icon"></i>
                              </label>
                            </td>
                            <td><b>{{ u.product_no }}</b></td>
                            <td>{{ u.product_name }}</td>
                            <td>
                              <select id="uom_id" v-model="u.uom_id" @change="setRow(u.id)">
                                <option v-for="u in u.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                              </select>
                            </td>
                            <td>
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="u.load === true"></span>
                              <span v-else>{{ u.total_begin }}</span>
                            </td>
                            <td>{{ u.total_purchasing }}</td>
                            <td>{{ u.total_adjust }}</td>
                            <td>{{ u.total_adjust_decrease }}</td>
                            <td>{{ u.return_purchasing }}</td>
                            <td>{{ u.total_onHand }}</td>
                            <td>{{ u.total_transfer }}</td>
                            <!-- <td>{{ u.total_stock_in }}</td> -->
                            <td>{{ u.total_sales }}</td>
                            <td>{{ u.return_sales }}</td>
                            <td>{{ u.total_convert_in }}</td>
                            <td>{{ u.total_convert_out }}</td>
                            <td>{{ u.total_material }}</td>
                            <!-- <td>{{ u.total_stock_out }}</td> -->
                            <td>
                              <span v-if="u.total_gudang_round_uom === u.total_gudang_decimal_uom">{{ u.total_gudang }}</span>
                              <span v-else>{{ u.total_gudang_round }} {{ u.total_gudang_round_uom }} {{ u.total_gudang_decimal }} {{ u.total_gudang_decimal_uom }}</span>
                            </td>
                            <td>
                              <span v-if="u.total_round_uom === u.total_decimal_uom">{{ u.total_remaining }}</span>
                              <span v-else>{{ u.total_remaining_round }} {{ u.total_round_uom }} {{ u.total_remaining_decimal }} {{ u.total_decimal_uom }}</span>
                            </td>
                            <td>
                              <span v-if="u.total_round_uom === u.total_decimal_uom">{{ u.total }}</span>
                              <span v-else>{{ u.total_round }} {{ u.total_round_uom }} {{ u.total_decimal }} {{ u.total_decimal_uom }}</span>
                            </td>
                            <td>
                              <span v-if="u.total_cost === u.total">{{ u.total_cost }} {{ u.total_cost_uom_id }} .</span>
                              <span v-else class="badge badge-danger">{{ u.total_cost }} {{ u.total_cost_uom_id }}</span>
                            </td>
                            <!-- <td>{{ u.total_order | currency }}</td> -->
                          </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
                <div class="tab-pane" id="summary-retur">
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                            <tr>
                                <th v-for="t in title3" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-if="filterData.length < 1">
                            <td colspan="7" style="text-align: center;"><i>No Data</i></td>
                          </tr>
                          <tr v-for="u in filterData" :key="u.id" style="cursor: pointer">
                            <td><b>{{ u.product_no }}</b></td>
                            <td>{{ u.product_name }}</td>
                            <td  v-if="u.uom_load === true">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </td>
                            <td v-else>
                              <select id="uom_id" v-model="u.uom_id" @change="setRow(u.id)">
                                <option v-for="u in u.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                              </select>
                            </td>
                            <td>{{ u.return_purchasing }}</td>
                            <td>{{ u.return_sales }}</td>
                            <td>
                              <span v-if="u.total_gudang_round_uom === u.total_gudang_decimal_uom">{{ u.total_gudang }}</span>
                              <span v-else>{{ u.total_gudang_round }} {{ u.total_gudang_round_uom }} {{ u.total_gudang_decimal }} {{ u.total_gudang_decimal_uom }}</span>
                            </td>
                            <td>
                              <span v-if="u.total_round_uom === u.total_decimal_uom">{{ u.total }}</span>
                              <span v-else>{{ u.total_round }} {{ u.total_round_uom }} {{ u.total_decimal }} {{ u.total_decimal_uom }}</span>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <ProductCostListModal @getSyncData="getSyncCOGSData"/>
    </div>
    <!-- <pre>{{ dataRaw }}</pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { product2Url, productUrl, setRowUrl, setQtyTotalUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import ProductCostListModal from '@/components/product/ProductCostListModal.vue'

export default {
  name: 'ProductSummaryList',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    ProductCostListModal
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const day1 = new Date().setFullYear(2022, 3, 1)
    // const date1 = new Date(day1)
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    const date1 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    return {
      branch: '001',
      warehouse: '',
      uomList: [],
      checkAvailable: true,
      checkKartuStock: false,
      filterKartuStock: false,
      filterDate: [date1, date2],
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      filterCategory: [],
      data: {},
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: 'product_name',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Product No',
        prop: 'product_no'
      }, {
        name: 'Name',
        prop: 'product_name'
      }, {
        name: 'Uom',
        prop: 'uom_id'
      }, {
        name: 'Begin',
        prop: 'total_begin'
      }, {
        name: 'Inventory',
        prop: 'total_purchasing'
      }, {
        name: 'Adjust',
        prop: 'total_adjust'
      }, {
        name: 'Adjust Decrease',
        prop: 'total_adjust_decrease'
      }, {
        name: 'Return',
        prop: 'return_purchasing'
      }, {
        name: 'On Hand',
        prop: 'total_onHand'
      }, {
        name: 'Transfer',
        prop: 'total_transfer'
      }, {
        name: 'Sales',
        prop: 'total_sales'
      }, {
        name: 'Return Sales',
        prop: 'return_sales'
      }, {
        name: 'Convert Out',
        prop: 'total_convert_in'
      }, {
        name: 'Convert In',
        prop: 'total_convert_out'
      }, {
        name: 'Materials',
        prop: 'total_material'
      }, {
        name: 'Total Gudang',
        prop: 'total_gudang'
      }, {
        name: 'Total Akumulasi',
        prop: 'total'
      }, {
        name: 'Total Kartu Stock',
        prop: 'total_cost'
      // }, {
      //   name: 'Order',
      //   prop: 'total_order'
      }],
      title2: [{
        name: 'Product No',
        prop: 'product_no'
      }, {
        name: 'Name',
        prop: 'product_name'
      }, {
        name: 'Uom',
        prop: 'uom_id'
      }, {
        name: 'Begin',
        prop: 'total_begin'
      }, {
        name: 'Inventory',
        prop: 'total_purchasing'
      }, {
        name: 'Adjust',
        prop: 'total_adjust'
      }, {
        name: 'Adjust Decrease',
        prop: 'total_adjust_decrease'
      }, {
        name: 'Return',
        prop: 'return_purchasing'
      }, {
        name: 'On Hand',
        prop: 'total_onHand'
      }, {
        name: 'Transfer',
        prop: 'total_transfer'
      }, {
        name: 'Sales',
        prop: 'total_sales'
      }, {
        name: 'Return Sales',
        prop: 'return_sales'
      }, {
        name: 'Convert Out',
        prop: 'total_convert_in'
      }, {
        name: 'Convert In',
        prop: 'total_convert_out'
      }, {
        name: 'Materials',
        prop: 'total_material'
      // }, {
      //   name: 'Total Gudang',
      //   prop: 'total_gudang'
      // }, {
      //   name: 'Total Akumulasi',
      //   prop: 'total'
      // }, {
      //   name: 'Total Kartu Stock',
      //   prop: 'total_cost'
      // }, {
      //   name: 'Order',
      //   prop: 'total_order'
      }],
      title3: [{
        name: 'Product No',
        prop: 'product_no'
      }, {
        name: 'Name',
        prop: 'product_name'
      }, {
        name: 'Uom',
        prop: 'uom_id'
      }, {
        name: 'Return Purchasing',
        prop: 'return_purchasing'
      }, {
        name: 'Return Sales',
        prop: 'return_sales'
      }, {
        name: 'Total Gudang',
        prop: 'total_gudang'
      }, {
        name: 'Total Akumulasi',
        prop: 'total'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.setUomList()
    this.setWh()
    console.log('getHeader: ')
    console.log(getHeader)
    // this.refreshProduct()
  },
  computed: {
    ...mapState({
      branchList: state => state.branches.branchList,
      warehouseList: state => state.warehouses.warehouseList,
      rowsTable: state => state.data.rowsTable,
      categoryList: state => state.products.productCategoryList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.checkKartuStock === true) {
              if (d.total_cost !== d.total_gudang) {
                return d
              }
            } else {
              return d
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.checkKartuStock === true) {
              if (this.warehouse === null) {
                if (d.total_cost !== d.total) {
                  return d
                }
              } else {
                if (d.total_cost !== d.total_gudang) {
                  return d
                }
              }
            } else {
              return d
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCategory.length > 0) {
          for (let i = 0; i < this.filterCategory.length; i++) {
            if (d.category_id === this.filterCategory[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.checkKartuStock === true) {
          if (this.warehouse === null || this.warehouse === '') {
            console.log(d.product_no)
            console.log(d.total_cost)
            console.log(d.total)
            console.log(d.total_gudang)
            if (parseFloat(d.total_cost) !== parseFloat(d.total)) {
              return d
            }
          } else {
            if (parseFloat(d.total_cost) !== parseFloat(d.total_gudang)) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        var start = (this.currentPage - 1) * this.pageSize
        var end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    },
    filterProduct: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCategory.length > 0) {
          for (let i = 0; i < this.filterCategory.length; i++) {
            if (d.category_id === this.filterCategory[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.checkKartuStock === true) {
          if (this.warehouse === null || this.warehouse === '') {
            console.log(d.product_no)
            console.log(d.total_cost)
            console.log(d.total)
            console.log(d.total_gudang)
            if (parseFloat(d.total_cost) !== parseFloat(d.total)) {
              return d
            }
          } else {
            if (parseFloat(d.total_cost) !== parseFloat(d.total_gudang)) {
              return d
            }
          }
        } else {
          return d
        }
      })
    }
  },
  methods: {
    async getSyncCOGSData (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      var date = new Date(value.date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var array = this.selected
      var resp = {
        error: false,
        message: null,
        data: []
      }
      for (let i = 0; i < array.length; i++) {
        var data = this.dataRaw.find(d => d.id === array[i])
        var obj = {
          date: newDate,
          product_no: data.product_no,
          type: 'all',
          company_no: value.company_no
        }
        console.log(obj)
        await axios.post(productUrl + '/cost/sync', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            resp.message = response.data.message
            resp.error = false
            var objresp = {
              product_no: obj.product_no
            }
            resp.data.push(objresp)
          })
          .catch(error => {
            console.log(error.response)
            this.$Progress.finish()
            this.loader.isLoading = false
            var msg = error.response.data.message + ' (' + obj.product_no + ')'
            this.$swal('Error', msg, 'error')
          })
      }
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        console.log('resp.data')
        console.log(resp.data)
        var respProduct = null
        for (let a = 0; a < resp.data.length; a++) {
          respProduct = respProduct == null ? resp.data[a].product_no + ', ' : respProduct + resp.data[a].product_no
        }
        var respMessage = resp.message + ' (' + resp.data.length + ') product' + '<br>' + '<pre>' + respProduct + '</pre>'
        this.$swal('Success', respMessage, 'success')
      }
    },
    async setQtyTotal (code) {
      const auth = JSON.parse(window.localStorage.getItem('authUser'))
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = auth.user.company_no

      await axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async setTotal () {
      var array = this.selected
      this.$Progress.start()
      this.loader.isLoading = true
      for (let i = 0; i < array.length; i++) {
        var data = this.dataRaw.find(d => d.id === array[i])
        await this.setQtyTotal(data.product_no)
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async exportExcel (type) {
      var data = {
        format: type,
        warehouse: this.warehouse,
        product: this.filterProduct
      }
      console.log(product2Url + '/export-summary-excel')
      await axios.post(product2Url + '/export-summary-excel', data, { responseType: 'blob' })
        .then(response => {
          console.log(response)
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Product Summary.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (var i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    setWh () {
      const auth = JSON.parse(window.localStorage.getItem('authUser'))
      this.warehouse = auth.user.warehouse_no
    },
    async refreshProduct () {
      const begin = this.filterDate[0] ? this.filterDate[0].getFullYear() + '-' + (this.filterDate[0].getMonth() + 1) + '-' + this.filterDate[0].getDate() : null
      const end = this.filterDate[1] ? this.filterDate[1].getFullYear() + '-' + (this.filterDate[1].getMonth() + 1) + '-' + this.filterDate[1].getDate() : null
      var subDate = new Date(this.filterDate[0])
      subDate.setDate(this.filterDate[0].getDate() - 1)
      const end2 = subDate ? subDate.getFullYear() + '-' + (subDate.getMonth() + 1) + '-' + subDate.getDate() : null
      let url = productUrl + '/summary?begin=' + begin + '&end=' + end + '&available=' + this.checkAvailable + '&warehouse=' + this.warehouse + '&cogs=false'
      let cogs = false
      await this.$swal.fire({
        title: 'Include COGS?',
        text: "You won't be able to revert this!",
        icon: 'Success',
        showCancelButton: true,
        confirmButtonColor: '#28A745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          url = productUrl + '/summary?begin=' + begin + '&end=' + end + '&available=' + this.checkAvailable + '&warehouse=' + this.warehouse + '&cogs=true'
          cogs = true
        }
      })
      console.log(url)
      this.$Progress.start()
      this.loader.isLoading = true
      await axios.get(url, { headers: getHeader(), timeout: 600000 })
        .then(response => {
          console.log(response.data.message)
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
        })
        .catch(error => {
          this.loader.isLoading = false
          console.log(error.message)
          this.$swal('Error', error.message, 'error')
          throw error
        })
      const arrData = this.dataRaw
      let countProcess = 0
      if (arrData.length > 0) {
        for (let i = 0; i < arrData.length; i++) {
          arrData[i].load = true
          const url = productUrl + '/summary-single?begin=&end=' + end2 + '&available=' + this.checkAvailable + '&warehouse=' + this.warehouse + '&product=' + arrData[i].product_no
          console.log('summary begin')
          await axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              var array2 = response.data.data
              var uoms = this.uomList.filter(u => u.product_no === arrData[i].product_no)
              arrData[i].uoms = uoms
              var lmData = array2.find(a => a.product_no === arrData[i].product_no)
              arrData[i].total_begin = arrData[i].total_begin + lmData.total_gudang
              arrData[i].total_gudang = arrData[i].total_gudang + lmData.total_gudang
              arrData[i].total = arrData[i].total + lmData.total
              arrData[i].begin_load = false
              arrData[i].total_remaining = arrData[i].total - arrData[i].total_gudang
              countProcess += 1
              arrData[i].load = false
            })
            .catch(error => {
              arrData[i].load = false
              console.log(error)
              this.$swal('Error', error.message, 'error')
            })
          if (cogs === false) {
            const url2 = productUrl + '/summary-single-cost?begin=&end=' + end + '&available=' + this.checkAvailable + '&warehouse=' + this.warehouse + '&product=' + arrData[i].product_no
            console.log('summary total_cost')
            await axios.get(url2, { headers: getHeader() })
              .then(response => {
                const summary = response.data.data[0]
                arrData[i].total_cost = summary.total_cost
                arrData[i].load = false
              })
              .catch(error => {
                arrData[i].load = false
                console.log(error)
                arrData[i].total_cost = '#'
                this.$swal('Error', error.message, 'error')
              })
          }
        }
      }
      if (this.dataRaw.length === countProcess) {
        this.$swal('Success', 'Finish process summary', 'success')
      }
    },
    loadTrue () {
      var array = this.dataRaw
      for (let a = 0; a < array.length; a++) {
        array[a].uom_load = true
        array[a].begin_load = true
      }
    },
    loadFalse () {
      var array = this.dataRaw
      for (let a = 0; a < array.length; a++) {
        array[a].uom_load = false
        array[a].begin_load = false
      }
    },
    async setUomList () {
      await axios.get(productUrl + '/uom', { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.uomList = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async setRow (id) {
      const begin = this.filterDate[0] ? this.filterDate[0].getFullYear() + '-' + (this.filterDate[0].getMonth() + 1) + '-' + this.filterDate[0].getDate() : null
      const end = this.filterDate[1] ? this.filterDate[1].getFullYear() + '-' + (this.filterDate[1].getMonth() + 1) + '-' + this.filterDate[1].getDate() : null
      var subDate = new Date(this.filterDate[0])
      subDate.setDate(this.filterDate[0].getDate() - 1)
      const end2 = subDate ? subDate.getFullYear() + '-' + (subDate.getMonth() + 1) + '-' + subDate.getDate() : null
      var pro = this.dataRaw.filter(p => p.id === id)
      pro[0].uom_load = false
      pro[0].begin_load = false
      console.log(setRowUrl + '?begin=' + begin + '&end=' + end + '&available=' + this.checkAvailable + '&warehouse=' + this.warehouse + '&product_no=' + pro[0].product_no + '&uom=' + pro[0].uom_id)
      await axios.get(setRowUrl + '?begin=' + begin + '&end=' + end + '&available=' + this.checkAvailable + '&warehouse=' + this.warehouse + '&product_no=' + pro[0].product_no + '&uom=' + pro[0].uom_id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          // console.log(response.data.data)
          var array = response.data.data
          console.log(setRowUrl + '?begin=&end=' + end2 + '&available=' + this.checkAvailable + '&warehouse=' + this.warehouse + '&product_no=' + pro[0].product_no + '&uom=' + pro[0].uom_id)
          axios.get(setRowUrl + '?begin=&end=' + end2 + '&available=' + this.checkAvailable + '&warehouse=' + this.warehouse + '&product_no=' + pro[0].product_no + '&uom=' + pro[0].uom_id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              var array2 = response.data.data
              // console.log(array2)
              pro[0].uom_id = array.uom_id
              pro[0].uom_load = false
              pro[0].total_begin = array2.total_gudang + array.total_begin
              pro[0].begin_load = false
              pro[0].total_purchasing = array.total_purchasing
              pro[0].total_onHand = array.total_onHand
              pro[0].total_stock_in = array.total_stock_in
              pro[0].total_sales = array.total_sales
              pro[0].total_return = array.total_return
              pro[0].rs = array.rs
              pro[0].total_convert_in = array.total_convert_in
              pro[0].total_convert_out = array.total_convert_out
              pro[0].total_material = array.total_material
              pro[0].total_workshop = array.total_workshop
              pro[0].total_stock_out = array.total_stock_out
              pro[0].total_transfer = array.total_transfer
              pro[0].total_gudang = array2.total_gudang + array.total_gudang
              pro[0].total_gudang_round = array2.total_gudang_round + array.total_gudang_round
              pro[0].total_gudang_round_uom = array.total_gudang_round_uom
              var tgd = array2.total_gudang_decimal + array.total_gudang_decimal
              pro[0].total_gudang_decimal = tgd.toFixed(2).replace(/\./g, ',')
              pro[0].total_gudang_decimal_uom = array.total_gudang_decimal_uom
              pro[0].total = array2.total + array.total
              pro[0].total_round = array2.total_round + array.total_round
              pro[0].total_round_uom = array.total_round_uom
              var trd = array2.total_decimal + array.total_decimal
              pro[0].total_decimal = trd.toFixed(2)
              pro[0].total_decimal_uom = array.total_decimal_uom
              pro[0].total_remaining = pro[0].total - pro[0].total_gudang
              pro[0].total_remaining_round = pro[0].total_round - pro[0].total_gudang_round
              pro[0].total_remaining_decimal = pro[0].total_decimal - pro[0].total_gudang_decimal
              pro[0].level = array.level
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
